import { useOutletContext } from 'react-router-dom';

/**
 * Reads `refreshSignal` from the parent layout's <Outlet context>.
 * Returns undefined when the page is rendered outside such a layout.
 */
const useOutletRefreshSignal = () => {
    const { refreshSignal } = useOutletContext() || {};
    return refreshSignal;
};

export default useOutletRefreshSignal;
